import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Layout',
		meta: {
		  title: '筑链'
		},
    component: () => import('@/Layout/index.vue'),
    children: [
      {
        path: '/',
        name: 'Home',
        component: () => import('@/views/Home/index.vue'),
        meta: {
          login: false,
          title: '首页'
        }
      },
      {
        path: '/Party',
        name: 'Party',
        component: () => import('@/views/Party/index.vue'),
        meta: {
          login: false,
          title: '甲方资源'
        }
      },
      {
        path: '/PartyDetail',
        name: 'PartyDetail',
        component: () => import('@/views/Party/detail.vue'),
        meta: {
          login: false,
          title: '资源详情'
        }
      },
      {
        path: '/TenderingDetail',
        name: 'TenderingDetail',
        component: () => import('@/views/Party/Tendering.vue'),
        meta: {
          login: false,
          title: '招标详情'
        }
      },
      {
        path: '/About',
        name: 'About',
        component: () => import('@/views/About/index.vue'),
        meta: {
          login: false,
          title: '关于筑链'
        }
      },
      {
        path: '/News',
        name: 'News',
        component: () => import('@/views/News/index.vue'),
        meta: {
          login: false,
          title: '通知中心'
        }
      },
      {
        path: '/NewsDetail',
        name: 'NewsDetail',
        component: () => import('@/views/News/detail.vue'),
        meta: {
          login: false,
          title: '通知中心'
        }
      }
    ]
  },

  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login/index.vue'),
    meta: {
      login: false,
      title: '登录'
    }
  },
  {
    path: '/forget',
    name: 'Forget',
    component: () => import('@/views/Forget/index.vue'),
    meta: {
      login: false,
      title: '找回密码'
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register/index.vue'),
    meta: {
      login: false,
      title: '注册'
    }
  },
  {
    path: '/member',
    name: 'Member',
    component: () => import('@/views/Member/index.vue'),
    meta: {
      login: true,
      title: '个人中心-充值会员'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// router.beforeEach((to, from, next) => {
//   var _hmt = _hmt || [];
//   (function() {
//     var hm = document.createElement("script");
//     hm.src = "https://hm.baidu.com/hm.js?b8f67b7ad05c3f334326638845611d9a";
//     var s = document.getElementsByTagName("script")[0]; 
//     s.parentNode.insertBefore(hm, s);
//   })();
// 	next();
// });

export default router
